export const documents = [
    { nom: "Acte de naissance - parent 1", destinataire: "parent 1" },
    { nom: "Acte de naissance - parent 2", destinataire: "parent 2" },
    { nom: "Livret de famille", destinataire: "commun" },
    // 📂 Documents d'identité et de domicile
    { nom: "Justificatif d'identité - parent 1", destinataire: "parent 1" },
    { nom: "Justificatif d'identité - parent 2", destinataire: "parent 2" },
    { nom: "Justificatif de domicile (facture ou attestation)", destinataire: "commun" },
    // 📂 Documents juridiques et engagements
    { nom: "Attestation de consentement mutuel", destinataire: "commun" },
    // 📂 Documents médicaux liés à la procédure PMA (si demandés par le notaire)
    { nom: "Certificat médical d’infertilité", destinataire: "parent 1" },
    { nom: "Accord de la Sécurité Sociale pour la prise en charge de la PMA", destinataire: "parent 1" },
    // 📂 Documents relatifs à l'enfant à naître (si applicable)
    { nom: "Projet parental écrit", destinataire: "commun" },
    { nom: "Déclaration d'engagement des parents", destinataire: "commun" }
];